export const environment = {
  production: false,
  baseUrl: 'https://dev.theradea.de',
  projectId: 'ips-icf',
  appId: '1:1057931415048:web:7c67f5e6856ee806d2cbbd',
  storageBucket: 'ips-icf.appspot.com',
  apiKey: 'AIzaSyDULX1Doz9BClNrC9qPXF6Vfwglrk7xhFs',
  authDomain: 'ips-icf.firebaseapp.com',
  messagingSenderId: '1057931415048',
};
